<template>
    <div class="modal fade" id="static-update-skip" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-md-dhk">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="modal-title w-100">
                        <h2 class="mt-0 title--1" v-html="'Are you sure?'"/>
                    </div>
                    <div class="modal__description">
                        <p class="modal__description__text my-3" v-html="`If you skip overdue tasks, they will be rescheduled with their correponding frequencies, starting from today's date.`"/>
                    </div>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <img width="15px" src="/assets/img/svg/close.svg" alt="Image"/>
                    </button>
                </div>
                <div class="modal__buttons mt-0 text-center text-md-right">
                    <button type="button" class="modal__buttons__item" @click="event_emition()" v-html="'Yes, skip & reschedule'"/>
                    <button type="button" data-dismiss="modal" class="modal__buttons__item" v-html="'No, keep current dates'"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

    name:   'SkipModal',
    
    props:  [
    ],

    methods:{
        event_emition()
        {
            window.$('#static-update-skip').modal('hide')
            this.$emit('objectSkip', true);
        }
    },

    mounted(){

    }
}
</script>